var LoadingStyle;
(function (LoadingStyle) {
    LoadingStyle["DEFAULT"] = "default";
    LoadingStyle["APP_INIT"] = "appInit";
})(LoadingStyle || (LoadingStyle = {}));

export { LoadingStyle };
